import { c as _c } from "react/compiler-runtime";
import { Separator, Flex, Stack, VStack } from '@chakra-ui/react';
import InteriorHero from '@src/components/sco/LayoutBlocks/InteriorHero';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { Paragraph } from '@src/components/sco/Paragraph.tsx';
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import privacyPolicyContent from '@src/data/privacy-policy.md';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect.tsx';
import { PageWithNavBar } from '@src/templates/PageWithNavBar.tsx';
export { getServerSideProps } from '@src/lib/server-side-rendering.tsx';
export default function Page() {
  const $ = _c(6);
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection?.("legal.privacy");
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useUniversalEffect(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <InteriorHero centerContent={true} description="We take your privacy seriously." title="Privacy Policy" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Paragraph fontSize="sm" fontStyle="italic" opacity={0.5}>Last Updated: July 10, 2025</Paragraph>;
    t3 = <Separator />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PageWithNavBar><Flex align="center" justify="center" width="full"><Stack align="center" direction="column" gap={0} width="full"><SectionWrapper>{t1}<VStack align="flex-start" gap={5} maxWidth="container.md" width="full">{t2}{t3}<MarkdownRenderer preset="privacyPolicy">{privacyPolicyContent.toString()}</MarkdownRenderer></VStack></SectionWrapper></Stack></Flex><SEOMetadata description="We take your privacy seriously." title="Privacy Policy" /></PageWithNavBar>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}